var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIcon18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#141414"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5380_773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1111 32.9999H17.8889C17.3978 32.9999 17 32.6021 17 32.111C17 31.6199 17.3978 31.2221 17.8889 31.2221H32.1111C32.6022 31.2221 33 31.6199 33 32.111C33 32.6021 32.6022 32.9999 32.1111 32.9999ZM21.1482 29.1481V21.4444C21.1482 20.9533 20.7505 20.5556 20.2594 20.5556C19.7683 20.5556 19.3705 20.9533 19.3705 21.4444V29.1481C19.3705 29.6393 19.7683 30.037 20.2594 30.037C20.7505 30.037 21.1482 29.6393 21.1482 29.1481ZM25.889 29.1481V25C25.889 24.5089 25.4912 24.1111 25.0001 24.1111C24.509 24.1111 24.1112 24.5089 24.1112 25V29.1481C24.1112 29.6393 24.509 30.037 25.0001 30.037C25.4912 30.037 25.889 29.6393 25.889 29.1481ZM30.6297 29.1481V17.8889C30.6297 17.3978 30.2319 17 29.7408 17C29.2497 17 28.8519 17.3978 28.8519 17.8889V29.1481C28.8519 29.6393 29.2497 30.037 29.7408 30.037C30.2319 30.037 30.6297 29.6393 30.6297 29.1481Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5380_773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(17 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon18);
export default __webpack_public_path__ + "static/media/nav_icon_18.0d1a84b1207b4bae875b09830c74f229.svg";
export { ForwardRef as ReactComponent };